import React, { useState } from "react";
import {
  Edit,
  SimpleForm,
  NumberInput,
  TextInput,
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
  SaveButton,
  AutocompleteInput,
  ReferenceInput,
  FormDataConsumer,
  TextField,
  DateField,
} from "react-admin";
import { Typography, Grid } from "@mui/material";
import { agreeStatus, paymentType, paymentStatus, dateOptions } from "../../../../utils/options";
import { editTitle } from "../../../../customStyles/ra-custom-styles";
import CustomDateInput from "common/components/Fields/CustomDateInput";
import InactiveDeleteOptionEditToolbar from "components/features/Partials/CustomComponents/InactiveDeleteOptionEditToolbar";
const typographyFont = { fontSize: "13px", color: "#9d9797" };
const EditSubscriptions = props => {
  const [invoice, setInvoice] = useState(null);
  const [invoiceGiven, setInvoiceGiven] = useState(null);
  const [additionalAddress, setAdditionalAddress] = useState(null);

  return (
    <Edit
      mutationMode="pessimistic"
      title="Абонаменти"
    >
      <Typography sx={editTitle}>Редакция на абонамент</Typography>
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveButton sx={{ marginBottom: "2rem" }} />
        <Grid
          container
          spacing={8}
        >
          <Grid
            item
            xs={12}
            md={6}
            lg={4}
          >
            <div style={{ marginBottom: "1.5em" }}>
              <Typography sx={typographyFont}>Номер на поръчката</Typography>
              <TextField source="subscription_id" />
              <Typography sx={typographyFont}>Аб.камп.</Typography>
              <TextField source="campaign_name" />
              <Typography sx={typographyFont}>Дата на заявка на абонамента</Typography>
              <DateField
                locales={"bg"}
                options={dateOptions}
                source="order_date"
              />
              <Typography sx={typographyFont}>Начало на абонамента</Typography>
              <DateField
                locales={"bg"}
                options={dateOptions}
                source="campaign_start_date"
              />
            </div>

            <TextInput
              label="Име на заявител"
              source="giver_first_name"
              fullWidth
            />
            <TextInput
              label="Фамилия на заявител"
              source="giver_last_name"
              fullWidth
            />
            <TextInput
              label="E-мейл на заявителя"
              source="giver_email"
              disabled
              fullWidth
            />
            <TextInput
              label="Телефон на заявителя"
              source="giver_phone_number"
            />

            <TextInput
              label="Име на получател"
              source="receiver_first_name"
              fullWidth
            />
            <TextInput
              label="Фамилия на получател"
              source="receiver_last_name"
              fullWidth
            />
            <TextInput
              label="Телефон на получател"
              source="receiver_phone_number"
              fullWidth
            />
            <TextInput
              label="E-мейл за доставка на ел изд."
              source="receiver_email"
              fullWidth
            />
            <ArrayInput
              label="Описание на поръчката"
              source="editions"
            >
              <SimpleFormIterator
                disableReordering
                disableRemove
                disableAdd
                inline
              >
                <TextInput
                  source="edition_name"
                  label="Име на издание"
                  disabled
                />
                <TextInput
                  source="editions_quantity"
                  label="Количество"
                  disabled
                  fullWidth
                />
                <TextInput
                  source="months_count"
                  label="Период на абонамента"
                  disabled
                  fullWidth
                />
              </SimpleFormIterator>
            </ArrayInput>
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            lg={4}
          >
            <NumberInput
              label="ПК"
              source="receiver_postcode"
              fullWidth
            />

            <ReferenceInput
              reference={`districts`}
              source="receiver_district_id"
            >
              <AutocompleteInput
                label="Област"
                optionText="name"
                fullWidth
              />
            </ReferenceInput>

            <FormDataConsumer>
              {({ formData }) =>
                formData.receiver_district_id ? (
                  <ReferenceInput
                    reference={`districts/${formData.receiver_district_id}/municipalities`}
                    source="receiver_municipality_id"
                  >
                    <AutocompleteInput
                      label="Община"
                      optionText="name"
                      fullWidth
                    />
                  </ReferenceInput>
                ) : null
              }
            </FormDataConsumer>
            <FormDataConsumer>
              {({ formData }) =>
                formData.receiver_district_id && formData.receiver_municipality_id ? (
                  <ReferenceInput
                    reference={`districts/${formData.receiver_district_id}/municipality/${formData.receiver_municipality_id}/cities`}
                    source="receiver_city_id"
                  >
                    <AutocompleteInput
                      label="Нас. място на получател / Град"
                      optionText="name_bg"
                      fullWidth
                    />
                  </ReferenceInput>
                ) : null
              }
            </FormDataConsumer>

            <TextInput
              label="Квартал"
              source="receiver_neighborhood"
              fullWidth
            />
            <TextInput
              label="Улица"
              source="receiver_street"
              fullWidth
            />
            <TextInput
              label="Номер"
              source="receiver_street_number"
              fullWidth
            />
            <TextInput
              label="Бл."
              source="receiver_building"
              fullWidth
            />
            <TextInput
              label="Вх."
              source="receiver_entrance"
              fullWidth
            />
            <NumberInput
              label="Ет."
              source="receiver_floor"
              fullWidth
            />
            <NumberInput
              label="Ап."
              source="receiver_apartment"
              fullWidth
            />
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            lg={4}
          >
            <NumberInput
              label="Цена Общо"
              source="total_sum"
              fullWidth
              disabled
            />
            <SelectInput
              label="Метод на плащане"
              source="payment_type"
              choices={paymentType}
              fullWidth
            />

            <SelectInput
              label="Статус на плащане"
              source="payment_status"
              choices={paymentStatus}
              fullWidth
            />
            <CustomDateInput
              label="Дата на плащане"
              source="purchase_date"
              fullWidth
            />
            <FormDataConsumer>
              {({ formData }) => {
                setInvoiceGiven(formData.is_invoice_ordered);
                return (
                  <SelectInput
                    label="Желае фактура"
                    source="is_invoice_ordered"
                    choices={agreeStatus}
                    onChange={e => {
                      e.target.value === true ? setInvoice(true) : setInvoice(false);
                    }}
                    fullWidth
                    sx={{ marginTop: "0px", marginBottom: " 0px" }}
                  />
                );
              }}
            </FormDataConsumer>
          </Grid>
          {(invoice || invoiceGiven) && (
            <Grid
              item
              xs={12}
            >
              <h2 style={{ marginLeft: ".1rem", fontWeight: "normal" }}>Данни за фактурата</h2>
              <Grid
                container
                spacing={8}
              >
                <Grid
                  item
                  xs={12}
                  lg={4}
                >
                  <NumberInput
                    label="ПК"
                    source="invoice_company_postal_code"
                    fullWidth
                  />
                  <SelectInput
                    label="Издадена фактура"
                    source="is_invoice_given"
                    choices={agreeStatus}
                    fullWidth
                  />
                  <TextInput
                    label="Фактура номер"
                    source="invoice_number"
                    fullWidth
                  />
                  <TextInput
                    label="Титуляр на фактурата"
                    source="invoice_company_name"
                    fullWidth
                  />
                  <TextInput
                    label="Идентификационен номер/ЕГН"
                    source="invoice_identification_number"
                    fullWidth
                  />

                  <TextInput
                    label="ИН по ЗДДС"
                    source="invoice_tax_id"
                    fullWidth
                  />
                  <TextInput
                    label="МОЛ"
                    source="invoice_accountable_person"
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={4}
                >
                  <ReferenceInput
                    reference={`districts`}
                    source="invoice_company_district_id"
                  >
                    <AutocompleteInput
                      label="Фирма - Област"
                      optionText="name"
                      fullWidth
                    />
                  </ReferenceInput>

                  <FormDataConsumer>
                    {({ formData }) =>
                      formData.invoice_company_district_id ? (
                        <ReferenceInput
                          reference={`districts/${formData.invoice_company_district_id}/municipalities`}
                          source="invoice_company_municipality_id"
                        >
                          <AutocompleteInput
                            label="Фирма - Община"
                            optionText="name"
                            fullWidth
                          />
                        </ReferenceInput>
                      ) : null
                    }
                  </FormDataConsumer>
                  <FormDataConsumer>
                    {({ formData }) =>
                      formData.invoice_company_district_id && formData.invoice_company_municipality_id ? (
                        <ReferenceInput
                          reference={`districts/${formData.invoice_company_district_id}/municipality/${formData.invoice_company_municipality_id}/cities`}
                          source="invoice_company_city_id"
                        >
                          <AutocompleteInput
                            label="Фирма - Град"
                            optionText="name_bg"
                            fullWidth
                          />
                        </ReferenceInput>
                      ) : null
                    }
                  </FormDataConsumer>
                  <TextInput
                    label="Фирма - Квартал"
                    source="invoice_company_neighborhood"
                    fullWidth
                  />
                  <TextInput
                    label="Фирма - Улица"
                    source="invoice_company_street"
                    fullWidth
                  />
                  <TextInput
                    label="Фирма - Номер на улица "
                    source="invoice_company_street_number"
                    fullWidth
                  />
                  <TextInput
                    label="Фирма - Блок"
                    source="invoice_company_building"
                    fullWidth
                  />
                  <TextInput
                    label="Фирма - Вход"
                    source="invoice_company_entrance"
                    fullWidth
                  />
                  <TextInput
                    label="Фирма - Етаж"
                    source="invoice_company_floor"
                    fullWidth
                  />
                  <TextInput
                    label="Фирма - Ап."
                    source="invoice_company_apartment"
                    fullWidth
                  />
                  <TextInput
                    label="Фирма - E-мейл"
                    source="invoice_company_email"
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={4}
                >
                  <FormDataConsumer>
                    {({ formData }) => {
                      setAdditionalAddress(formData.invoice_add_billing_address);
                      return (
                        <SelectInput
                          label="Въвеждане на допълнителен адрес"
                          source="invoice_add_billing_address"
                          choices={agreeStatus}
                          onChange={e => {
                            e.target.value === true ? setAdditionalAddress(true) : setAdditionalAddress(false);
                          }}
                          fullWidth
                        />
                      );
                    }}
                  </FormDataConsumer>
                  {additionalAddress && (
                    <>
                      <ReferenceInput
                        reference={`districts`}
                        source="invoice_billing_district_id"
                      >
                        <AutocompleteInput
                          label="Допълнителен адрес за получаване - Област"
                          optionText="name"
                          fullWidth
                        />
                      </ReferenceInput>

                      <FormDataConsumer>
                        {({ formData }) =>
                          formData.invoice_billing_district_id ? (
                            <ReferenceInput
                              reference={`districts/${formData.invoice_billing_district_id}/municipalities`}
                              source="invoice_billing_municipality_id"
                            >
                              <AutocompleteInput
                                label="Допълнителен адрес за получаване - Община"
                                optionText="name"
                                fullWidth
                              />
                            </ReferenceInput>
                          ) : null
                        }
                      </FormDataConsumer>
                      <FormDataConsumer>
                        {({ formData }) =>
                          formData.invoice_billing_district_id && formData.invoice_billing_municipality_id ? (
                            <ReferenceInput
                              reference={`districts/${formData.invoice_billing_district_id}/municipality/${formData.invoice_billing_municipality_id}/cities`}
                              source="invoice_billing_city_id"
                            >
                              <AutocompleteInput
                                label="Допълнителен адрес за получаване - Град"
                                optionText="name_bg"
                                fullWidth
                              />
                            </ReferenceInput>
                          ) : null
                        }
                      </FormDataConsumer>

                      <TextInput
                        label="Допълнителен адрес за получаване - Квартал"
                        source="invoice_billing_neighborhood"
                        fullWidth
                      />
                      <TextInput
                        label="Допълнителен адрес за получаване - Улица"
                        source="invoice_billing_street"
                        fullWidth
                      />
                      <TextInput
                        label="Допълнителен адрес за получаване - Номер на улица"
                        source="invoice_billing_street_number"
                        fullWidth
                      />
                      <TextInput
                        label="Допълнителен адрес за получаване - Бл."
                        source="invoice_billing_building"
                        fullWidth
                      />
                      <TextInput
                        label="Допълнителен адрес за получаване - Вх."
                        source="invoice_billing_entrance"
                        fullWidth
                      />
                      <TextInput
                        label="Допълнителен адрес за получаване - Ет."
                        source="invoice_billing_floor"
                        fullWidth
                      />
                      <TextInput
                        label="Допълнителен адрес за получаване - Ап."
                        source="invoice_billing_apartment"
                        fullWidth
                      />
                      <TextInput
                        label="Допълнителен адрес за получаване - Фактура"
                        source="invoice_billing_company_name"
                        fullWidth
                      />
                      <TextInput
                        label="Допълнителен E-мейл"
                        source="invoice_billing_email"
                        fullWidth
                      />
                      <TextInput
                        label="Допълнителен ПК"
                        source="invoice_billing_postal_code"
                        fullWidth
                      />

                      <TextInput
                        label="Лице за контакт"
                        source="invoice_billing_accountable_person"
                        fullWidth
                      />
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          )}

          <Grid
            item
            xs={12}
            sx={{
              "& .RaSimpleFormIterator-form": {
                width: "80%",
              },
            }}
          >
            <h2 style={{ marginLeft: ".1rem", fontWeight: "normal" }}>Рекламация на Абонамент</h2>
            <ArrayInput
              source="subscription_complaints"
              label=""
            >
              <SimpleFormIterator disableReordering>
                <TextInput
                  source="complaint"
                  label="Рекламация "
                  multiline
                  fullWidth
                />
                <TextInput
                  source="answer"
                  label="Отговор"
                  multiline
                  fullWidth
                />
              </SimpleFormIterator>
            </ArrayInput>
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};

export default EditSubscriptions;
